import { TranslatedText } from "@/components/common/text";
import { trailerTypeSymbols, TruckStatus } from "@/utils/constants";

const TrailerTypePill = ({ type }) => {
    const label = (trailerTypeSymbols[type] || "V") === "V" ? "VAN" : (type ?? "").toString().toUpperCase();
    return (
        <span className="flex items-center justify-center h-[20px] px-[6px] rounded-[4px] bg-cm-p-surface-container text-cm-p-text-primary text-[12px] font-medium tracking-[-0.12px]">
            {label}
        </span>
    );
};

const LoadStatusPill = ({ status }) => {
    const isFree = status === TruckStatus.FREE.id;
    const isOffDuty = status === TruckStatus.OFF_DUTY.id;
    const colorClasses = isFree
        ? "bg-cm-p-container-red text-cm-p-on-container-red"
        : isOffDuty
          ? "bg-cm-p-surface-container text-cm-p-text-secondary"
          : "bg-cm-p-surface-container text-cm-p-text-primary";
    const label = isFree ? "no load" : isOffDuty ? "off duty" : "on route";
    return (
        <span
            className={`flex items-center justify-center h-[20px] px-[6px] py-[4px] rounded-[4px] text-[12px] font-medium uppercase tracking-[-0.12px] ${colorClasses}`}
        >
            <TranslatedText>{label}</TranslatedText>
        </span>
    );
};

const FilterStatusPill = ({ hasFilter }) => (
    <span
        className={`flex items-center justify-center h-[20px] px-[6px] py-[4px] rounded-[4px] text-[12px] font-medium uppercase tracking-[-0.12px] ${
            hasFilter ? "bg-cm-p-accent-50 text-cm-p-on-container-green" : "bg-cm-p-container-orange text-cm-p-on-container-orange"
        }`}
    >
        <TranslatedText>{hasFilter ? "has filter" : "no filter"}</TranslatedText>
    </span>
);

const HeaderButton = ({ onClick, disabled, children }) => (
    <button
        onClick={onClick}
        disabled={disabled}
        className={`flex items-center justify-center h-full px-[16px] py-[8px] rounded-[6px] bg-cm-p-surface-container border-[1.2px] border-cm-p-outline text-cm-p-on-container-green text-[12px] font-medium ${
            disabled ? "opacity-50 cursor-not-allowed" : ""
        }`}
    >
        {children}
    </button>
);

export const LoadFinderHeader = ({ selectedTruck, filterCount = 0, onAdjustStrategy, onNewFilter }) => {
    // No truck selected means the lists are still loading or the caller has no trucks at all (the
    // sidebar covers that case) — the page selects one as soon as there is one, so keep the bar
    // empty rather than prompting for a selection that happens on its own.
    if (!selectedTruck) {
        return <div className="bg-cm-p-surface border-b border-cm-p-outline px-5 py-3 h-[63px]" />;
    }

    const status = selectedTruck.status || TruckStatus.FREE.id;
    const hasFilter = filterCount > 0;

    return (
        <div className="bg-cm-p-surface border-b border-cm-p-outline px-5 py-3 h-[63px]">
            <div className="flex items-center gap-3 h-[38px] px-[4px]">
                <span className="text-[20px] font-medium text-cm-p-text-primary tracking-[-0.2px] whitespace-nowrap">
                    {selectedTruck.truckName}
                </span>
                <div className="flex items-center gap-2 shrink-0">
                    <TrailerTypePill type={selectedTruck.trailerType} />
                    <LoadStatusPill status={status} />
                    <FilterStatusPill hasFilter={hasFilter} />
                </div>
                <HeaderButton onClick={onAdjustStrategy}>
                    <TranslatedText>Adjust strategy</TranslatedText>
                </HeaderButton>
                <HeaderButton onClick={onNewFilter}>
                    <TranslatedText>New filter</TranslatedText>
                </HeaderButton>
            </div>
        </div>
    );
};
